import React from 'react';
import Navbar from '../components/layout/Navbar';

const Tech: React.FC = () => {
  return (
    <div className="relative min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-28 pb-12 bg-white relative overflow-hidden">
        {/* Left Tool Imprint - Smaller Gear */}
        <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/3 opacity-[0.04] pointer-events-none">
          <svg width="220" height="220" viewBox="0 0 24 24" fill="currentColor" className="text-slate-900">
            <path d="M12 15.5A3.5 3.5 0 0 1 8.5 12A3.5 3.5 0 0 1 12 8.5A3.5 3.5 0 0 1 15.5 12A3.5 3.5 0 0 1 12 15.5M19.43 12.97C19.47 12.65 19.5 12.33 19.5 12C19.5 11.67 19.47 11.34 19.43 11L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.54 5.05 19.27 4.96 19.05 5.05L16.56 6.05C16.04 5.66 15.5 5.32 14.87 5.07L14.5 2.42C14.46 2.18 14.25 2 14 2H10C9.75 2 9.54 2.18 9.5 2.42L9.13 5.07C8.5 5.32 7.96 5.66 7.44 6.05L4.95 5.05C4.73 4.96 4.46 5.05 4.34 5.27L2.34 8.73C2.21 8.95 2.27 9.22 2.46 9.37L4.57 11C4.53 11.34 4.5 11.67 4.5 12C4.5 12.33 4.53 12.65 4.57 12.97L2.46 14.63C2.27 14.78 2.21 15.05 2.34 15.27L4.34 18.73C4.46 18.95 4.73 19.03 4.95 18.95L7.44 17.94C7.96 18.34 8.5 18.68 9.13 18.93L9.5 21.58C9.54 21.82 9.75 22 10 22H14C14.25 22 14.46 21.82 14.5 21.58L14.87 18.93C15.5 18.67 16.04 18.34 16.56 17.94L19.05 18.95C19.27 19.03 19.54 18.95 19.66 18.73L21.66 15.27C21.78 15.05 21.73 14.78 21.54 14.63L19.43 12.97Z"/>
          </svg>
        </div>
        
        {/* Right Tool Imprint - Gear */}
        <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/3 opacity-[0.04] pointer-events-none">
          <svg width="280" height="280" viewBox="0 0 24 24" fill="currentColor" className="text-slate-900">
            <path d="M12 15.5A3.5 3.5 0 0 1 8.5 12A3.5 3.5 0 0 1 12 8.5A3.5 3.5 0 0 1 15.5 12A3.5 3.5 0 0 1 12 15.5M19.43 12.97C19.47 12.65 19.5 12.33 19.5 12C19.5 11.67 19.47 11.34 19.43 11L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.54 5.05 19.27 4.96 19.05 5.05L16.56 6.05C16.04 5.66 15.5 5.32 14.87 5.07L14.5 2.42C14.46 2.18 14.25 2 14 2H10C9.75 2 9.54 2.18 9.5 2.42L9.13 5.07C8.5 5.32 7.96 5.66 7.44 6.05L4.95 5.05C4.73 4.96 4.46 5.05 4.34 5.27L2.34 8.73C2.21 8.95 2.27 9.22 2.46 9.37L4.57 11C4.53 11.34 4.5 11.67 4.5 12C4.5 12.33 4.53 12.65 4.57 12.97L2.46 14.63C2.27 14.78 2.21 15.05 2.34 15.27L4.34 18.73C4.46 18.95 4.73 19.03 4.95 18.95L7.44 17.94C7.96 18.34 8.5 18.68 9.13 18.93L9.5 21.58C9.54 21.82 9.75 22 10 22H14C14.25 22 14.46 21.82 14.5 21.58L14.87 18.93C15.5 18.67 16.04 18.34 16.56 17.94L19.05 18.95C19.27 19.03 19.54 18.95 19.66 18.73L21.66 15.27C21.78 15.05 21.73 14.78 21.54 14.63L19.43 12.97Z"/>
          </svg>
        </div>

        <div className="relative max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            The tools that make the difference.
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            You can have the best leads in the world, but without the right systems, you're leaving money on the table. 
            Here's what our agents use every day.
          </p>
        </div>
      </section>

      {/* CLOSIO CRM Section */}
      <section className="py-16 bg-black relative overflow-hidden">
        {/* Background Image - Imprinted */}
        <div className="absolute inset-0 opacity-[0.07]">
          <img 
            src="/insurance logos/Main closio logo.png" 
            alt="" 
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-auto"
          />
        </div>
        
        <div className="relative max-w-5xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            {/* Content */}
            <div>
              <span className="inline-block px-3 py-1 bg-white/10 text-white/80 text-xs font-semibold rounded-full mb-4 uppercase tracking-wider">
                CRM Platform
              </span>
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
                Closio CRM
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Most agents are tracking leads in spreadsheets or worse, in their head. That works until you're juggling 50 prospects
                and can't remember who you called last Tuesday.
              </p>
              <p className="text-gray-300 mb-8 leading-relaxed">
                Closio keeps everything in one place. Every lead, every call, every policy. You know exactly where every deal stands 
                and what needs attention next. No more leads falling through the cracks.
              </p>
              
              <div className="grid grid-cols-2 gap-3">
                {[
                  "Lead tracking",
                  "Reminders & calendar", 
                  "Commission visibility",
                  "Stats dashboard",
                  "Mobile access",
                  "Book of business"
                ].map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-white/60"></div>
                    <span className="text-sm text-gray-300">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Image */}
            <div className="flex justify-center lg:justify-end">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent rounded-2xl blur-xl"></div>
                <img 
                  src="/insurance logos/Main closio logo.png" 
                  alt="Closio CRM" 
                  className="relative w-64 sm:w-72 h-auto rounded-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Discord Section */}
      <section className="py-16 bg-[#5865F2] relative overflow-hidden">
        {/* Background Image - Imprinted */}
        <div className="absolute inset-0 opacity-[0.08]">
          <img 
            src="/insurance logos/Discord-Blog-Article-scaled.jpg" 
            alt="" 
            className="absolute top-1/2 right-0 translate-x-1/4 -translate-y-1/2 w-[500px] h-auto"
          />
        </div>
        
        <div className="relative max-w-5xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            {/* Image - Left side on desktop */}
            <div className="flex justify-center lg:justify-start order-2 lg:order-1">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent rounded-2xl blur-xl"></div>
                <img 
                  src="/insurance logos/Discord-Blog-Article-scaled.jpg" 
                  alt="Discord Community" 
                  className="relative w-64 sm:w-72 h-auto rounded-2xl shadow-2xl"
                />
              </div>
            </div>
            
            {/* Content */}
            <div className="order-1 lg:order-2">
              <span className="inline-block px-3 py-1 bg-white/20 text-white text-xs font-semibold rounded-full mb-4 uppercase tracking-wider">
                Community & Support
              </span>
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
                Discord
              </h2>
              <p className="text-white/90 mb-6 leading-relaxed">
                Insurance can be lonely. You're on your own, figuring things out, wondering if you're doing it right. 
                That's why we built a community where agents actually help each other.
              </p>
              <p className="text-white/90 mb-8 leading-relaxed">
                Stuck on a case? Ask in the channel. Need a script that works? Someone's sharing theirs. 
                Want to celebrate a big week? People actually care. It's not corporate. It's agents talking to agents.
              </p>
              
              <div className="grid grid-cols-2 gap-3">
                {[
                  "Real-time chat",
                  "Voice rooms", 
                  "Resource library",
                  "Direct access to leadership",
                  "Win celebrations",
                  "Script sharing"
                ].map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-white/70"></div>
                    <span className="text-sm text-white/90">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Readymode Section */}
      <section className="py-16 bg-navy-900 relative overflow-hidden">
        {/* Background Image - Imprinted */}
        <div className="absolute inset-0 opacity-[0.06]">
          <img 
            src="/insurance logos/readymode.webp" 
            alt="" 
            className="absolute top-1/2 left-1/4 -translate-x-1/2 -translate-y-1/2 w-[500px] h-auto"
          />
        </div>
        
        <div className="relative max-w-5xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            {/* Content */}
            <div>
              <span className="inline-block px-3 py-1 bg-white/10 text-white/80 text-xs font-semibold rounded-full mb-4 uppercase tracking-wider">
                Power Dialer
              </span>
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
                Readymode
              </h2>
              <p className="text-navy-200 mb-6 leading-relaxed">
                You bought leads. Now you need to actually talk to them. Manually dialing? You'll burn out before lunch. 
                That's where the dialer comes in.
              </p>
              <p className="text-navy-200 mb-8 leading-relaxed">
                Readymode dials multiple lines at once, connects you only when someone picks up, and shows you their info before you say hello. 
                You talk to 3x more people in the same amount of time. More conversations = more sales. Simple math.
              </p>
              
              <div className="grid grid-cols-2 gap-3">
                {[
                  "Triple-line dialing",
                  "Local caller ID", 
                  "Call recording",
                  "Real-time stats",
                  "Lead routing",
                  "CRM sync"
                ].map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-navy-400"></div>
                    <span className="text-sm text-navy-200">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Image */}
            <div className="flex justify-center lg:justify-end">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-navy-600/20 to-transparent rounded-2xl blur-xl"></div>
                <img 
                  src="/insurance logos/readymode.webp" 
                  alt="Readymode Dialer" 
                  className="relative w-64 sm:w-72 h-auto rounded-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Bottom Line Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-4">
            This is what separates agents who struggle from agents who scale.
          </h2>
          <p className="text-slate-600 mb-8 max-w-2xl mx-auto">
            The leads matter. The products matter. But the systems you use every day? 
            That's what determines whether you're working smart or just working hard.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="/apply"
              className="w-full sm:w-auto px-8 py-4 bg-navy-700 text-white font-semibold rounded-xl hover:bg-navy-800 transition-colors shadow-lg"
            >
              Get Access
            </a>
            <a
              href="/lead-catalog"
              className="w-full sm:w-auto px-8 py-4 bg-white text-slate-700 font-semibold rounded-xl border-2 border-slate-200 hover:border-slate-300 transition-colors"
            >
              See Our Leads
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Tech;
